import { useId } from 'react';

import { attemptSourceText } from './attemptSettings';
import type { TimingChoice, TimingSource } from './questionTimingSettings';
import styles from './ChapterTimingField.module.css';

interface ChapterTimingFieldProps {
  // What the chapter gets when it sets nothing, and where that comes from.
  followedLabel: string;
  followedSource: TimingSource;
  label: string;
  // The dialog's own style for a label around its select.
  labelClassName: string;
  onChange(value: string): void;
  options: readonly TimingChoice[];
  // '' follows the course. Otherwise the value saved on the chapter.
  value: string;
}

// A hint or solutions select for a chapter's Question Settings, with a line
// saying where the value comes from (issue #144). The line is the select's
// description, and it is read out when it changes.
export function ChapterTimingField({
  followedLabel,
  followedSource,
  label,
  labelClassName,
  onChange,
  options,
  value,
}: ChapterTimingFieldProps) {
  const hintId = useId();

  return (
    <div className={styles.field}>
      <label className={labelClassName}>
        <span>{label}</span>
        <select
          aria-describedby={hintId}
          onChange={(event) => onChange(event.target.value)}
          value={value}
        >
          <option value="">Use course default ({followedLabel})</option>
          {options.map((option) => (
            <option key={option.value} value={String(option.value)}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      <p aria-live="polite" className={styles.hint} id={hintId}>
        {attemptSourceText(value === '' ? followedSource : 'chapter', 'chapter')}
      </p>
    </div>
  );
}
